"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _validationTriggers = require("../../../constants/validation/validationTriggers");

var _ErrorDisplay = _interopRequireDefault(require("../../TextElements/FormattedTextElements/ErrorDisplay"));

var _validate = require("../../../utils/inputValidator/validate");

var _Select = require("./Select.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A configurable select component that will both take theming and can be easily styled to suit
 * the user's needs.
 *
 * In contrast to inputs, this takes a list of options formatted in the following way:
 *
 * {
 *  value: {aValue}
 *  label: {labelForAValue}
 * }
 *
 * Also in contrast to inputs, and at the request of the team at this time, this is an entirely
 * controlled component including **selected value and errors**. In order for these to function
 * as designed, the developer will need to pass them back to the Select.
 *
 * Lastly, only some of the many available props for React-Select are explicitly defined in this
 * component, however all props provided to this component will be passed to the Select. For a
 * complete list of these, reference these docs:
 *
 * https://react-select.com/props
 */
var Select = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var value = e ? e.value : '';

      _this.validateInput({
        type: _validationTriggers.CHANGE,
        value: value
      });

      return _this.props.onChange && _this.props.onChange(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var selectedOption = _this.props.selectedOption;
      var value = selectedOption ? selectedOption.value : '';

      _this.validateInput({
        type: _validationTriggers.BLUR,
        value: value
      });

      return _this.props.onBlur && _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var selectedOption = _this.props.selectedOption;
      var value = selectedOption ? selectedOption.value : '';

      _this.validateInput({
        type: _validationTriggers.FOCUS,
        value: value
      });

      return _this.props.onFocus && _this.props.onFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$type = _ref.type,
          type = _ref$type === void 0 ? undefined : _ref$type,
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? _this.props.selectedOption ? _this.props.selectedOption.value : '' : _ref$value;

      var _this$props = _this.props,
          currentErrors = _this$props.errors,
          hoistErrors = _this$props.hoistErrors;

      var errors = _this.validate({
        type: type,
        value: value,
        currentErrors: currentErrors
      });
      /**
       * This will both hoist errors to the parent for normal controlled operation and
       * will return errors for situations where a ref needs to be called
       */


      hoistErrors(errors);
      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "validateAllRules", function () {
      var value = _this.props.selectedOption.value;
      var _this$props2 = _this.props,
          currentErrors = _this$props2.errors,
          hoistErrors = _this$props2.hoistErrors;

      var errors = _this.validate({
        value: value,
        currentErrors: currentErrors
      });
      /**
       * This will both hoist errors to the parent for normal controlled operation and
       * will return errors for situations where a ref needs to be called
       */


      hoistErrors(errors);
      return errors;
    });

    _this.validate = (0, _validate.validate)({
      displayName: props.name,
      rules: props.validationRules
    });
    return _this;
  }

  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          dataTestId = _this$props3.dataTestId,
          name = _this$props3.name,
          errors = _this$props3.errors,
          isClearable = _this$props3.isClearable,
          isSearchable = _this$props3.isSearchable,
          label = _this$props3.label,
          options = _this$props3.options,
          selectedOption = _this$props3.selectedOption,
          suppressErrorSection = _this$props3.suppressErrorSection;
      return /*#__PURE__*/_react.default.createElement(_Select.SelectWrapper, {
        dataTestId: dataTestId,
        isSearchable: isSearchable
      }, label && /*#__PURE__*/_react.default.createElement(_Select.StyledLabel, {
        htmlFor: name,
        className: "c-labeled-input-label",
        "data-test-id": "labeled-input-label"
      }, label), /*#__PURE__*/_react.default.createElement(_Select.StyledSelect, _extends({}, this.props, {
        /**
         * blurInputOnSelect is necessary to avoid a race condition
         * for validation and errors due to this being a controlled
         * component
         *
         * i.e. The blur event after a change event will fire before a
         * rerender and therefore before any validation errors from the
         * change event can update the component
         */
        blurInputOnSelect: false,
        classNamePrefix: "c-react-select",
        hasErrors: errors.length,
        isClearable: isClearable,
        isSearchable: isSearchable,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onSubmit: this.handleSubmit,
        options: options,
        value: selectedOption,
        placeholder: isSearchable ? 'Search ...' : 'Select One'
      })), !suppressErrorSection && /*#__PURE__*/_react.default.createElement(_ErrorDisplay.default, {
        errors: errors
      }));
    }
  }]);

  return Select;
}(_react.default.PureComponent);

_defineProperty(Select, "propTypes", {
  /** Testing ID */
  dataTestId: _propTypes.default.string.isRequired,

  /** Name for validation/error messages */
  name: _propTypes.default.string.isRequired,

  /** Array of any validation errors */
  errors: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Hoists any errors */
  hoistErrors: _propTypes.default.func.isRequired,

  /** Flag for allowing selection to be cleared */
  isClearable: _propTypes.default.bool,

  /** Flag for allowing typing in a select */
  isSearchable: _propTypes.default.bool,

  /** Optional Label for the Select */
  label: _propTypes.default.string,

  /**
   * Hoists the blur event.
   * NOTE: THIS DOES NOT HOIST THE SELECTED VALUE
   */
  onBlur: _propTypes.default.func,

  /** Hoists selected value on change */
  onChange: _propTypes.default.func.isRequired,

  /**
   * Hoists the focus event.
   * NOTE: THIS DOES NOT HOIST THE SELECTED VALUE
   */
  onFocus: _propTypes.default.func,

  /** Options to include in the select list */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  }).isRequired).isRequired,

  /** Currently selected option */
  selectedOption: _propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  }),

  /** flag for suppressing the errors section until you have errors */
  suppressErrorSection: _propTypes.default.bool,

  /** Validation rules for the select. It's generally advisable to only use `REQUIRED` */
  validationRules: _propTypes.default.shape({})
});

_defineProperty(Select, "defaultProps", {
  errors: [],
  isClearable: true,
  isSearchable: false,
  label: undefined,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  selectedOption: undefined,
  suppressErrorSection: false,
  validationRules: {}
});

var _default = (0, _styledComponents.withTheme)(Select);

exports.default = _default;